import { render, staticRenderFns } from "./HighRatingFilters.vue?vue&type=template&id=77181e96&"
import script from "./HighRatingFilters.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HighRatingFilters.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77181e96')) {
      api.createRecord('77181e96', component.options)
    } else {
      api.reload('77181e96', component.options)
    }
    module.hot.accept("./HighRatingFilters.vue?vue&type=template&id=77181e96&", function () {
      api.rerender('77181e96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/HighRatingFilters/HighRatingFilters.vue"
export default component.exports